import * as ReactDOM from "react-dom";
import * as React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { BrowserRouter as Router } from "react-router-dom";

import { msalConfig } from "./authConfig";

import { ApplicationInsights } from "@microsoft/applicationinsights-web";

// Import Tailwind CSS
import "./main.css";

declare global {
    const IdentityServerUrl: string;
    const IdentityAuthority: string;
    const ServiceManagerUrl: string;
    const IdentityClientID: string;
    const DefaultOrganization: string;
    const EntityTypeID: string;
    const WasteTemplateID: string;
    const WasteFormID: string;
    const DisposalCertificateQuestionID: string;
    const CreateUserNameOptionKey: string;
    const CreateUserEmailOptionKey: string;
    const CreateUserTelephoneOptionKey: string;
}

const appInsights = new ApplicationInsights({
    config: {
        connectionString:
            "InstrumentationKey=178c6ad6-01e9-46b2-8f15-9490d2bc22c8;IngestionEndpoint=https://uaenorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://uaenorth.livediagnostics.monitor.azure.com/",
    },
});
appInsights.loadAppInsights();
appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview

export const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if ((event.eventType === EventType.LOGIN_SUCCESS || event.eventType == EventType.ACQUIRE_TOKEN_SUCCESS) && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        msalInstance.setActiveAccount(account);
    }
});

import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
pdfjs.fetchData;
const container = document.getElementById("app");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
    <Router>
        <link type="text/css" href={IdentityServerUrl + "static/branding/theme"} rel="stylesheet" />
        <App pca={msalInstance} />
    </Router>
);
